module.exports = __webpack_public_path__ + "static/digipay-healthguard-8c2bfe644920ce835196fad299877541.png";